module.exports = __webpack_public_path__ + "4d7e55168c1aef460fe74307d827ae2b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/unimpressed-26.png
// module id = 2359
// module chunks = 0